import { render, staticRenderFns } from "./TranslationItem.vue?vue&type=template&id=1b617f38&scoped=true&"
import script from "./TranslationItem.vue?vue&type=script&lang=js&"
export * from "./TranslationItem.vue?vue&type=script&lang=js&"
import style0 from "./TranslationItem.vue?vue&type=style&index=0&id=1b617f38&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b617f38",
  null
  
)

export default component.exports